module.exports = __webpack_public_path__ + "img/capitalOne.2ef7fc2e.png";